<!--能力评价-->
<template>
  <a-card>
    <div class="search">
      <a-form-model layout="inline" :model="searchForm">
        <a-form-model-item label="能力名称">
          <a-input :maxLength="30" allowClear class="serach-item" v-model="searchForm.abilityName" placeholder="请输入能力名称" />
        </a-form-model-item>
        <a-form-model-item label="评价等级类型">
          <a-select class="serach-item" allowClear v-model="searchForm.levelNumber" placeholder="请选择评价等级类型">
            <a-select-option value="">全部</a-select-option>
            <a-select-option value="0">能力类型</a-select-option>
            <a-select-option value="1">能力等级</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="评价体系">
          <a-select class="serach-item" allowClear v-model="searchForm.abilityEvaluationSysId" placeholder="请选择评价体系">
            <a-select-option :value="item.id" v-for="item in abilityEvaluation" :key="item.id">{{ item.name }} </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item style="margin-right: 35px">
          <a-button @click="getPageList(1)" type="primary" html-type="button"> 查询 </a-button>
          <a-button @click="searchReset" style="margin-left: 10px"> 重置 </a-button>
        </a-form-model-item>
        <a-form-model-item v-permission="`abilityEvaluate.Add`">
          <a-button @click="getAllLoadallsel" icon="plus" type="primary">添加模板</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div style="overflow: auto; margin-top: 15px">
      <a-table
        style="min-width: 800px"
        :columns="columns"
        :rowKey="(text, index) => text.id + '-' + index"
        :pagination="tableRelevant.tablePagination"
        :loading="tableRelevant.tableLoading"
        :locale="tableRelevant.locale"
        :dataSource="tableRelevant.tableDataSource"
      >
        <span slot="abilityName" slot-scope="text">
          {{ text.abilityCode ? text.abilityName + `（${text.abilityCode}）` : text.abilityName }}
        </span>
        <span slot="abilityType" slot-scope="text">
          {{ text === 0 ? '能力类型' : '能力等级' }}
        </span>
        <span v-auth="`abilityEvaluate.Status`" slot="status" slot-scope="text">
          <a-switch @change="tableStatusChange(text)" v-model="text.enabled" checked-children="启用" un-checked-children="禁用" />
        </span>
        <div slot="action" slot-scope="text">
          <a v-permission="`abilityEvaluate.Edit`" @click="edit(text)" style="margin-right: 10px" href="javaScript:;">
            <a-icon type="edit" />
            编辑</a
          >
          <a-popconfirm title="确认删除此能力评价？" @confirm="del(text)">
            <a v-permission="`abilityEvaluate.Delete`" style="color: red" href="javaScript:;">
              <a-icon type="delete" />
              删除</a
            >
          </a-popconfirm>
        </div>
      </a-table>
    </div>

    <!--添加/编辑能力评价-->
    <a-modal
      v-model="modelForm.visible"
      :centered="true"
      :destroyOnClose="true"
      :title="modelForm.title"
      :confirm-loading="modelForm.confirmLoading"
      @cancel="modelFormCancel"
      @ok="modelFormOk"
      width="800px"
    >
      <a-form-model ref="myModelForm" style="max-height: 400px; overflow-y: auto" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }" :model="modelForm.data" :rules="modelForm.rules">
        <a-form-model-item label="能力类型" prop="abilityId">
          <a-tree-select
            v-model="modelForm.data.abilityId"
            style="width: 100%"
            :treeDefaultExpandedKeys="[modelForm.data.abilityId]"
            :replaceFields="{ title: 'name', key: 'id', value: 'id' }"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :tree-data="modelForm.treeData"
            placeholder="请选择能力类型"
          >
          </a-tree-select>
        </a-form-model-item>
        <a-form-model-item label="评价模板" prop="abilityEvaluationSysId" ref="abilityEvaluationSysId">
          <a-select @change="getInforBySysId" :getPopupContainer="() => $refs.abilityEvaluationSysId.$el" v-model="modelForm.data.abilityEvaluationSysId" placeholder="请选择评价模板">
            <a-select-option :value="item.id" v-for="item in abilityEvaluation" :key="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="评价等级" prop="abilityLevelId" ref="abilityLevelId">
          <a-select v-model="modelForm.data.abilityLevelId" :getPopupContainer="() => $refs.abilityLevelId.$el" placeholder="请选择评价等级">
            <a-select-option :value="item.id" v-for="item in modelForm.referenceLevel" :key="item.id">
              {{ item.abilityLevel }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="评价类型" prop="referenceTypeId" ref="referenceTypeId">
          <a-select v-model="modelForm.data.referenceTypeId" :getPopupContainer="() => $refs.referenceTypeId.$el" placeholder="请选择评价类型">
            <a-select-option :value="item.id" v-for="item in modelForm.referenceType" :key="item.id">
              {{ item.referenceType }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-radio-group v-model="modelForm.data.enabled">
            <a-radio :value="true">启用</a-radio>
            <a-radio :value="false">禁用</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="内容描述" prop="content">
          <a-textarea v-model="modelForm.data.content" placeholder="请输入内容描述" :auto-size="{ minRows: 3, maxRows: 8 }" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'

const columns = [
  {
    title: '能力名称',
    scopedSlots: { customRender: 'abilityName' },
    width: 250,
    ellipsis: true,
  },
  {
    title: '能力等级类型',
    dataIndex: 'abilityType',
    scopedSlots: { customRender: 'abilityType' },
  },
  {
    title: '评价模板',
    dataIndex: 'evaluationName',
  },
  {
    title: '评价类型',
    dataIndex: 'referenceType',
  },
  {
    title: '评价等级',
    dataIndex: 'abilityLevel',
  },
  {
    title: '等级说明',
    dataIndex: 'levelDescription',
    ellipsis: true,
  },
  {
    title: '内容描述',
    dataIndex: 'content',
    ellipsis: true,
  },
  {
    title: '状态',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '操作',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  name: 'AbilityEvaluate',
  data() {
    return {
      columns,
      searchForm: {
        abilityName: '',
        levelNumber: '',
        abilityEvaluationSysId: undefined,
      },
      //评价体系列表
      abilityEvaluation: [],
      //表格相关
      tableRelevant: tableRelevant.call(this),
      modelForm: {
        visible: false,
        confirmLoading: false,
        title: '添加能力评价',
        //评价体系下拉列表
        treeData: [],
        referenceLevel: [],
        referenceType: [],
        data: {
          id: undefined,
          abilityId: undefined,
          abilityEvaluationSysId: undefined,
          abilityLevelId: undefined,
          referenceTypeId: undefined,
          content: '',
          enabled: true,
        },
        rules: {
          abilityId: [{ required: true, message: '请选择能力类型', trigger: 'change' }],
          abilityEvaluationSysId: [{ required: true, message: '请选择评价模板', trigger: 'change' }],
          abilityLevelId: [{ required: true, message: '请选择评价等级', trigger: 'change' }],
          referenceTypeId: [{ required: true, message: '请选择评价类型', trigger: 'change' }],
          content: [{ required: true, message: '请输入内容描述', trigger: 'blur' }],
        },
      },
    }
  },
  mounted() {
    this.getPageList()
    this.getAbilityEvaluation()
  },
  methods: {
    //获取能力评价列表
    getPageList(pageIndex) {
      if (pageIndex) {
        this.tableRelevant.tablePagination.current = pageIndex
      }
      const params = {
        pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        ...this.searchForm,
      }
      this.tableRelevant.tableLoading = true
      this.$http.ReportService.getAbilitylevelReference(params)
        .then((res) => {
          const { data } = res
          this.tableRelevant.tableDataSource = data.items
          this.tableRelevant.tablePagination.total = data.totalCount
        })
        .finally(() => {
          this.tableRelevant.tableLoading = false
        })
    },
    //获取评价体系列表
    getAbilityEvaluation() {
      if (!this.abilityEvaluation.length) {
        this.$http.ReportService.getAbilityEvaluationSys().then((res) => {
          const { data } = res
          this.abilityEvaluation = data.filter((f) => f.enabled)
        })
      }
    },
    //获取评价体系列表
    getInforBySysId(id) {
      this.$http.ReportService.getinforbysysid(id).then((res) => {
        const { data, status, message } = res
        this.modelForm.referenceLevel = data.referenceLevel.filter((f) => f.enabled)
        this.modelForm.referenceType = data.referenceType.filter((f) => f.enabled)
      })
    },
    //获取五大能力
    getAllLoadallsel() {
      this.modelForm.visible = true
      let params = {
        AbilityType: 0,
      }
      if (!this.modelForm.treeData.length) {
        this.$http.CommonInterface.getAllLoadallsel(params).then((res) => {
          const { data } = res
          this.modelForm.treeData = data
        })
      }
    },

    //重置
    searchReset() {
      this.searchForm = {
        abilityName: '',
        levelNumber: '',
        abilityEvaluationSysId: undefined,
      }
      this.getPageList(1)
    },
    //能力评价列表状态切换
    tableStatusChange(val) {
      this.$message.destroy()
      this.tableRelevant.tableLoading = true
      this.$http.ReportService.statusAbilitylevelReference(val.id)
        .then((res) => {
          const { message } = res
          this.$message.success(message)
        })
        .finally(() => {
          this.tableRelevant.tableLoading = false
        })
    },
    //编辑能力评价
    edit(val) {
      this.modelForm.title = '编辑模板'
      this.getAllLoadallsel()
      this.getInforBySysId(val.abilityEvaluationSysId)
      for (let key in this.modelForm.data) {
        this.modelForm.data[key] = val[key]
      }
    },
    //删除能力评价
    del(val) {
      this.tableRelevant.tableLoading = true
      this.$http.ReportService.deleteAbilitylevelReference(val.id)
        .then((res) => {
          this.$message.success(res.message)
          this.getPageList(1)
        })
        .finally(() => {
          this.tableRelevant.tableLoading = false
        })
    },

    //弹出框确认
    modelFormOk() {
      this.$refs.myModelForm.validate((valid) => {
        if (valid) {
          const bool = this.modelForm.title === '添加能力评价'
          const Ajax = bool ? this.$http.ReportService.addAbilitylevelReference : this.$http.ReportService.upateAbilitylevelReference
          if (bool) delete this.modelForm.data.id
          const reference = this.modelForm.referenceType.find((item) => this.modelForm.data.referenceTypeId == item.id)
          this.modelForm.confirmLoading = true
          Ajax({ ...this.modelForm.data, referenceType: reference.referenceType })
            .then((res) => {
              const { message } = res
              this.$message.success(message)
              this.modelFormCancel()
              this.getPageList(1)
            })
            .finally(() => {
              this.modelForm.confirmLoading = false
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    //弹出框取消
    modelFormCancel() {
      this.modelForm.visible = false
      this.modelForm.title = '添加能力评价'
      this.modelForm.data = {
        id: undefined,
        abilityId: undefined,
        abilityEvaluationSysId: undefined,
        abilityLevelId: undefined,
        referenceTypeId: undefined,
        content: '',
        enabled: true,
      }
    },
  },
}
</script>

<style scoped>
.serach-item {
  width: 180px;
}
</style>
